export default "__VITE_ASSET__CTMxwMyJ__"